var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("manage-authentication-view", {
    key: _vm.domain,
    attrs: {
      "for-domain": _vm.domain
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }